import Vue from 'vue';
import 'common/reset.scss';
import 'common/elementUi.js';
import axios from 'common/axios';
import MessageBox from './message-box';
import Log from './log.js';
Vue.use(MessageBox);
Vue.use(Log);
